/**
 * Namespace
 */
export const NAMESPACE = 'FLYOUT';
